<template>
  <div>
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="班级名称">
        <Input
          v-model="searchCondition.class_name"
          placeholder="请输入班级名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="所属课程">
        <Input
          v-model="searchCondition.course_name"
          placeholder="请输入课程名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="班级类型">
        <Select v-model="searchCondition.class_type" style="width:200px;" clearable>
          <Option v-for="item in class_type" :key="item.key" :value="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="讲师名称">
        <Input
          v-model="searchCondition.teacher_name"
          placeholder="请输入讲师名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="助教名称">
        <Input
          v-model="searchCondition.assistant_name"
          placeholder="请输入助教名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <Form-item label="创建时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px;"
          @on-change="onDateRange"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Date-picker>
      </Form-item>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button
        type="primary"
        :to="{name: 'ClassEdit',query:{type: 2}}"
        style="margin-right:50px;"
      >新增班级</Button>
      <Checkbox v-model="onlyShowMe" @on-change="onMineChange">只看我创建的</Checkbox>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/classGrade"
        :search="searchCondition"
        @onSelectionChange="onSelectionChange"
        :rowsFormatter="rowsFormatter"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              :to="{name:'ClassEdit', query:{id: row.id, type: 1}}"
            >编辑</Button>
            <span>-</span>
            <Button type="text" size="small" :to="{name:'StudentList', query:{id: row.id}}">学员列表</Button>
            <span v-if="showHomeworkModule">-</span>
            <Button v-if="showHomeworkModule" type="text" size="small" :to="{name:'HomeworkList', query:{id: row.id}}">作业列表</Button>
            <span>-</span>
            <Button type="text" size="small" @click="openModal(row)">复制</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onForbidden(row.id)">删除</Button>
          </div>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            size="small"
            @click="onForbidden(0)"
            :disabled="selectItems.length==0"
          >删除</Button>
        </template>
      </Grid>
    </div>
    <Modal title="复制班级" v-model="showModal" @on-ok="copy" @on-cancel="showModal=false">
      <Form ref="copy" :label-width="100" :model="copyData" :rules="ruleCopy" inline>
        <FormItem label="班级名称：" prop="class_name">
          <Input v-model="copyData.class_name" style="width:300px;" clearable></Input>
        </FormItem>
        <FormItem label="复制内容：">
          复制班级基本信息-包含课程相关信息，
          <br />无学员加入班级前可修改课程信息
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { ClassType } from "@/utils/enums";
export default {
  name: "ClassManage",
  data() {
    return {
      class_type: ClassType.getOptions(),
      searchCondition: {
        class_name: "",
        course_name: "",
        teacher_name: "",
        assistant_name: "",
        class_type: 0,
        start_time: "",
        end_time: "",
        only_me: "",
        init: function() {
          this.class_name = "";
          this.course_name = "";
          this.teacher_name = "";
          this.assistant_name = "";
          this.class_type = 0;
          this.start_time = "";
          this.end_time = "";
        }
      },
      onlyShowMe: false,
      tableColumns: [
        { title: "所属课程", key: "course_name", minWidth: 180 },
        { title: "班级名称", key: "class_name", minWidth: 180 },
        { title: "班级类型", key: "class_type_name", minWidth: 100 },
        { title: "讲师名称", key: "teacher_name", minWidth: 120 },
        { title: "助教名称", key: "assistant_name", minWidth: 120 },
        {
          title: "班级人数",
          key: "student_number",
          minWidth: 100,
          align: "center"
        },
        {
          title: "创建时间",
          key: "created_at",
          minWidth: 160,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          minWidth: 240,
          align: "center"
        }
      ],
      selectItems: [],
      showModal: false,
      copyData: {
        class_name: "",
        id: ""
      },
      ruleCopy: {
        class_name: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      showHomeworkModule: false
    };
  },
  async created() {
    let commonSetting = await this.$http.get("/api/commonSetting");
    this.showHomeworkModule = commonSetting.homework_module.is_open == 1;
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.class_type_name = ClassType.getValue(item.class_type);
        item.created_at = this.$pub.timestampToTime(item.created_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.init();
      } else {
        this.searchCondition.only_me = this.onlyShowMe ? 1 : "";
      }
      this.$refs.grid.searchRefresh();
    },
    async onMineChange() {
      await this.search(1);
    },
    onSelectionChange(items) {
      this.selectItems = items;
    },
    /**
     * @param {Number} type   1 发布 2撤回 3删除
     * @param {String} id    试卷id
     */
    onForbidden(id) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除该班级吗？</p>",
        onOk: () => {
          this.nextAction(id);
        }
      });
    },
    nextAction(id) {
      let ids = "";
      if (id) {
        ids = id;
      } else {
        this.selectItems.forEach(item => {
          ids += item.id + ",";
        });
        ids = ids.substr(0, ids.length - 1);
      }
      this.$http.delete("/api/classGrade/" + ids).then(() => {
        this.$Message.deleteSuccess();
        this.$refs.grid.searchRefresh();
        this.selectItems = [];
      });
    },
    onDateRange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    },
    openModal(row) {
      this.showModal = true;
      this.copyData.id = row.id;
      this.copyData.class_name = row.class_name + "副本";
    },
    copy() {
      this.$refs.copy.validate(valid => {
        if (valid) {
          this.$http
            .post(`/api/classGrade/copy`, {
              ...this.copyData
            })
            .then(() => {
              this.search(1);
            });
        } else {
          return;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
  .modal-item {
    border: 1px solid #eee;
    width: 180px;
    padding: 20px;
    cursor: pointer;
    .modal-item-title {
      text-align: center;
      margin-bottom: 10px;
    }
  }
}
</style>